// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import moment from 'moment-timezone'
import VueResource from 'vue-resource'
import BootstrapVue from 'bootstrap-vue'
import VueAnalytics from 'vue-analytics'
import VueTheMask from 'vue-the-mask'
import vueNumeralFilterInstaller from 'vue-numeral-filter'
import Viewer from 'v-viewer'
import VCalendar from 'v-calendar'
import VueCookie from 'vue-cookie'
import VueClipboard from 'vue-clipboard2'
import money from 'v-money'
import linkify from 'vue-linkify'
import { EmojiPickerPlugin } from 'vue-emoji-picker'

import 'bootstrap/dist/js/bootstrap.js'

import './assets/icomoon-material/style.css'

import './assets/scss/icon-library/style.css'

import './assets/scss/style.scss'

import 'animate.css'

moment.tz.setDefault('America/Sao_Paulo')

Vue.config.productionTip = false

Vue.use(VueResource)
Vue.use(BootstrapVue)
Vue.use(VueTheMask)
Vue.use(VueAnalytics, {
  id: 'UA-132314477-3'
})

Vue.use(Viewer)
Vue.use(VCalendar)
Vue.use(VueCookie)
Vue.use(VueClipboard)
Vue.use(money, {precision: 1})
Vue.use(EmojiPickerPlugin)

Vue.use(vueNumeralFilterInstaller, { locale: 'pt-br' })

Vue.directive('linkified', linkify)

Vue.http.options.root = process.env.API

Vue.use(require('@websanova/vue-auth'), {
  // auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/vue-resource.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  rolesVar: 'roles',
  auth: {
    request: function (req, token) {
      token = token.split(';')
      token =
        req.url.indexOf('refresh') > -1 || req.url.indexOf('logout') > -1
          ? token[1]
          : token[0]
      this.options.http._setHeaders.call(this, req, {
        Authorization: 'Bearer ' + token
      })
    },
    response: function (res) {
      // console.log(res)
      if (res.data.access_token && res.data.refresh_token) {
        return res.data.access_token + ';' + res.data.refresh_token
      }
    }
  },
  authRedirect: '/pages/login',
  loginData: {
    url: 'api/validate',
    method: 'GET',
    redirect: '/',
    fetchUser: true
  },
  fetchData: { url: 'api/validate', method: 'GET', enabled: false },
  refreshData: {
    url: 'api/validate',
    method: 'GET',
    enabled: true,
    interval: 10
  },
  logoutData: { url: 'api/logout' },
  parseUserData (response) {
    // TODO verificar se tem como modificar retorno backend - https://github.com/websanova/vue-auth/issues/236
    console.log('parse ' + response)
    console.log(response)
    // this.$auth.user(response)
    return response
  }
})

/* eslint-disable no-new */
App.router = Vue.router

Vue.filter('moment', function (date) {
  moment.locale('pt-br')
  return moment
    .utc(date)
    .tz('America/Sao_Paulo')
    .format('DD MMM')
})

Vue.filter('moment-month', function (date) {
  moment.locale('pt-br')
  return moment
    .utc(date)
    .tz('America/Sao_Paulo')
    .format('DD/MM')
})

Vue.filter('moment-hour', function (date) {
  moment.locale('pt-br')
  return moment
    .utc(date)
    .tz('America/Sao_Paulo')
    .format('HH:mm')
})

Vue.filter('moment-complete', function (date) {
  moment.locale('pt-br')
  return moment
    .utc(date)
    .tz('America/Sao_Paulo')
    .format('ddd, DD MMMM YYYY HH:mm:ss')
})

Vue.filter('moment-date-hour', function (date) {
  moment.locale('pt-br')
  return moment(date).format('DD/MM/YYYY HH:mm:ss')
})

Vue.filter('moment-date-hour-min', function (date) {
  moment.locale('pt-br')
  return moment(date).format('DD/MM HH:mm')
})

Vue.filter('moment-date-year-hour-min', function (date) {
  moment.locale('pt-br')
  return moment(date).format('DD/MM/YYYY HH:mm')
})

Vue.filter('moment-date', function (date) {
  moment.locale('pt-br')
  if (date.indexOf('/' > 0)) {
    return date
  } else {
    return moment(date).format('DD/MM/YYYY')
  }
})

Vue.filter('moment-date-dash', function (date) {
  moment.locale('pt-br')
  return moment(date).format('DD/MM/YYYY')
})

Vue.filter('moment-short-date', function (date) {
  moment.locale('pt-br')
  const today = new Date()
  var m = moment.utc(date).toDate()
  if (
    m.getDate() === today.getDate() &&
    m.getMonth() === today.getMonth() &&
    m.getFullYear() === today.getFullYear()
  ) {
    return moment
      .utc(date)
      .tz('America/Sao_Paulo')
      .format('HH:mm')
  } else {
    return moment
      .utc(date)
      .tz('America/Sao_Paulo')
      .format('DD MMM')
  }
})

Vue.filter('moment-timestamp', function (date) {
  moment.locale('pt-br')
  return moment.unix(date).format('HH:mm')
})

Vue.filter('phone-format', function (phone) {
  if (phone.length === 11) {
    return phone.replace(/[^0-9]/g, '')
      .replace(/(\d{2})(\d{5})(\d{4})/, '$1 $2-$3')
  } else {
    return phone.replace(/[^0-9]/g, '')
      .replace(/(\d{2})(\d{4})(\d{4})/, '$1 $2-$3')
  }
})

Vue.filter('cpf-format', function (cpf) {
  return cpf.replace(/[^0-9]/g, '')
    .replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  resource: VueResource,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js